import paletteEngine from "src/pages/dynamic_forms/Utils/paletteEngine"
import palette from "./palette"
import DynamicFormPaletteTypes from "./types"

const initialState: Array<DynamicFormPaletteTypes> = [...palette]

const copy: Array<DynamicFormPaletteTypes> = JSON.parse(JSON.stringify([...palette]))

export function dynamicFormPaletteReducer(state = initialState, action: { type: string, payload: string | Array<DynamicFormPaletteTypes> }) {
    for (let i = 0; i < palette.length; i++) {
        if (palette[i].dispatchKey === action.type) {
            //@ts-ignore
            palette[i].hexCode = action.payload
            return [...palette]
        }
    }
    if (action.type === "MERGE_EXISTING_FORM_PALETTE") {
        //@ts-ignore
        const payload: Array<DynamicFormPaletteTypes> = action.payload
        for (let i = 0; i < palette.length; i++) {
            for (let j = 0; j < payload.length; j++) {
                if (payload[j].key === palette[i].key) {
                    palette[i].hexCode = payload[j].hexCode
                }
            }
        }
        const mergedPalette = [...palette]
        paletteEngine.setDefaultPalette(copy)
        return mergedPalette
    }
    if (action.type === "RESET_DYNAMIC_FORM_PALETTE") {
        for (let i = 0; i < copy.length; i++) {
            palette[i].hexCode = copy[i].hexCode
        }
        return [...palette]
    }
    return state
}